// extracted by mini-css-extract-plugin
export default {"matchList":"nTG_S"};